export default {
	serveList: '/business_lines', // 业务线下拉列表
	versionList: '/system/app/versions/list', // 版本列表
	addNewVersion: '/system/app/versions', // 添加新版本
	versionsAudit: '/system/app/versions/flag_audit/', // 版本审核
	setMealLists: '/admin/packages/list', //套餐配置列表
	addSetMeal: '/admin/packages', // 新增套餐配置
	setMealSize: '/admin/packages/specification_list', // EW下单-套餐规格
	setMealDetail: '/admin/packages', // 详情
	setMealUpload: '/admin/packages', // 更新
	setMealHistoryLists: '/admin/packages/{id}/history-list', // 套餐-历史版本
	setMealFunctionItemLists: '/admin/packages/{packageVersionId}/{currency}/function-item-list', // 套餐版本-功能列表

	addFeature: '/admin/function_items', // 新增功能配置
	activeFeatureList: '/admin/function_items/all_enable_list', // 已启用的功能列表
	featureList: '/admin/function_items/list', // 功能配置列表
	featreSize: '/admin/function_items/specification_list', // EW下单-功能规格
	setRenew: '/admin/function_items/{id}/flag', // 续费 任务流 新增 变更 客户自主下单 按钮的开关
	featureDetail: '/admin/function_items', // 详情
	featureUpdate: '/admin/function_items', // 更新功能
	featureEnabled: '/admin/function_items/{id}/enable', // 是否启用工能
	businessLine: '/dictionary/dictionaryList', // 业务线数据
	enabledWechatPremission: '/admin/packages/{id}/enable_applet_permissions', // 是否启用小程序权限
	areRenewalsAllowed: '/admin/packages/{id}/allow_renewal', // 是否允许续费
	setmealUpdate: '/admin/packages', // 更新套餐
	setmealEnabled: '/admin/packages/{id}/enable', // 是否启用套餐
	getPackageTypeList: '/admin/packages/type_list', // 获取套餐类型下拉列表

	// 自动优惠券
	couponsConfigList: '/coupons/config/list', // 分页列表
	addCoupons: '/coupons/config', // 新建
	couponsDetails: '/coupons/config/{id}', // 详情
	editCoupons: '/coupons/config/{id}', // 编辑
	couponsIsEnabled: '/coupons/config/{id}/enable', // 是否启用
	couponsPackagesChoose: '/coupons/config/packages', // 套餐选择
	featureDropDownList: '/admin/function_items/all_list', // 功能下拉列表

	// 灰度和权限配置
	grayscaleList: '/iglobalwin-sso-api/menupermissions/gray-menu', // 灰度列表
	releaseGrayscaleVersion: '/iglobalwin-sso-api/menupermissions/publish-gray-menu/{id}', // 发布灰度版本
	redactGrayscaleList: '/iglobalwin-sso-api/menupermissions/customer-gray-menu/{id}', // 灰度客户列表
	addGrayscale: '/iglobalwin-sso-api/menupermissions/customer-gray-menu', // 添加灰度客户
	deleteGrayscale: '/iglobalwin-sso-api/menupermissions/customer-gray-menu/{id}', // 删除灰度客户
	updateGrayscaleName: '/iglobalwin-sso-api/menupermissions/gary-name',

	roleList: '/iglobalwin-sso-api/role/selectrole', // 系统默认角色列表
	queryMenuPermission: '/iglobalwin-sso-api/menupermissions/selectmenupermissions/{roleId}', //菜单权限数据查询
	editRole: '/iglobalwin-sso-api/role/editrole', //编辑角色

	// 白名单
	allowNewOrder: '/admin/packages/{id}/allow_new_order', //是否允许新单
	allowRenewWhiteList: '/admin/packages/{id}/allow_renew_white_list', // 是否允许续费白名单
	renewWhiteList: '/admin/packages/renew_white_list/list', // 分页列表
	manyServiceList: '/admin/packages/renew_white_list/many-service-list', // 多服务单效验列表
	addRenewWhiteList: '/admin/packages/renew_white_list', // 续费白名单-新增
	deleteRenewWhiteList: '/admin/packages/renew_white_list/{id}', // 续费白名单-删除
	editRenewWhiteList: '/admin/packages/renew_white_list/{id}', // 续费白名单-更新
	batchDeleteRenewWhiteList: '/admin/packages/renew_white_list/batch', // 续费白名单-批量删除
	affiliatedPermissionsList: '/admin/function_items/affiliated_permissions_list', // 挂靠权限列表
	functionItemsTypeList: '/admin/function_items/type_list', // 功能类型列表
};
